import { computed, ref, watch } from 'vue'
import { freshAdminImage } from '@/utils/adminFreshness'

export function productImageUrls(product, preferSecondary = false) {
  const images = Array.isArray(product?.images) && product.images.length
    ? product.images
    : [product?.image, product?.image_2, product?.image_3]
  const ordered = preferSecondary && images.length > 1
    ? [images[1], images[0], ...images.slice(2)]
    : images
  return [...new Set(ordered
    .filter(url => typeof url === 'string' && url.trim())
    .map(url => freshAdminImage(url, product)))]
}

// Cada vista recuerda las URLs que fallaron solo mientras muestra este producto.
export function useImageGallery(sourceImages) {
  const failed = ref([])
  const imageIndex = ref(0)
  watch(sourceImages, () => {
    failed.value = []
    imageIndex.value = 0
  }, { immediate: true })
  const images = computed(() => sourceImages.value.filter(url => !failed.value.includes(url)))
  const currentImage = computed(() => images.value[imageIndex.value] || images.value[0] || null)
  const markFailed = (url) => {
    if (!images.value.includes(url)) return
    failed.value = [...failed.value, url]
    imageIndex.value = 0
  }
  const onImageError = (event) => {
    const attempted = event.currentTarget.getAttribute('src')
    if (attempted === currentImage.value) markFailed(attempted)
  }
  const onThumbnailError = (url, event) => {
    if (event.currentTarget.getAttribute('src') === url) markFailed(url)
  }
  return { images, imageIndex, currentImage, onImageError, onThumbnailError }
}
